import { useRef } from 'react'
import { useCheckout } from '../../../components/Checkout/CheckoutContext'
import Checkout from '../../../components/Checkout/Checkout'
import CompletingOrder, {
  type CompletingOrderHandle,
} from '../../../pages/CompletingOrder/CompletingOrder'
import { type CreateOrderParams } from '../../../services/OrderManager.types'
import { useBagAnalytics } from '../hooks/useBagAnalytics'
import { useCartDrawer } from './CartDrawerProvider'
import CartDrawer from './CartDrawer'

function CartFlow() {
  const { isCartOpen, closeCart } = useCartDrawer()
  const { openCheckout } = useCheckout()
  const { getBagProps } = useBagAnalytics()
  const completingOrderRef = useRef<CompletingOrderHandle>(null)

  const callCreateOrder = (
    orderData: Omit<CreateOrderParams, 'bagAnalytics'>
  ) => {
    completingOrderRef.current!.createOrder({
      ...orderData,
      bagAnalytics: getBagProps(),
    })
  }

  const onCheckoutClick = () => {
    closeCart()
    openCheckout()
  }

  return (
    <>
      <CartDrawer
        open={isCartOpen}
        onClose={closeCart}
        onCheckout={onCheckoutClick}
        callCreateOrder={callCreateOrder}
      />
      <Checkout
        isCartFlow
        completingOrderRef={completingOrderRef}
        callCreateOrder={callCreateOrder}
      />
      <CompletingOrder ref={completingOrderRef} isCartFlow />
    </>
  )
}

export default CartFlow
